export const isNumeric = (value: string) => {
  return /^\d+$/.test(value);
};
